import "./Footer.css";

export default function Footer() {
  return (
    <div>
      <footer>
        Coded by{" "}
        <a href="https://github.com/duff-e" target="_blank" rel="noreferrer">
          Elise Duffy
        </a>{" "}
        is open sourced by{" "}
        <a
          href="https://github.com/duff-e/weather-app-react"
          target="_blank"
          rel="noreferrer"
        >
          Github
        </a>{" "}
        and hosted on{" "}
        <a
          href="https://imaginative-profiterole-d24d37.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          Netlify
        </a>
      </footer>
    </div>
  );
}
